import { BaseService } from './baseService';

class InboundNumberReservationsService extends BaseService<
    InboundNumberReservation,
    'inboundNumberReservationID',
    'inboundNumberReservations'
> {
    constructor() {
        super('inboundNumberReservationID', 'inboundNumberReservation', 'inboundNumberReservations');
    }
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new InboundNumberReservationsService();
